import React, { useContext } from 'react'

import Article from '@/components/shared/article'
import { CMSProvider } from '@/context/cms'
import SubCategoryContext from '@/context/sub-category'

const CmsContent: React.FC = () => {
    const {
        selectors: { subCategory },
    } = useContext(SubCategoryContext)

    return (
        <CMSProvider article={subCategory?.article}>
            <Article />
        </CMSProvider>
    )
}

export default CmsContent
